import { createAction } from '@reduxjs/toolkit';

export const removeRecordAllowancesByRecordIds = createAction(
  'recordAllowances/removeRecordAllowancesByRecordIds'
);
